module.exports = __webpack_public_path__ + "554f48bd8b279d044ca3b095914a383d.woff";